import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

export interface IUtil {
    stableSlopeAssessmentTable: boolean;
    drainageCapacityTable: boolean;
    drainingDrainPipesCalculationTable: boolean;
    wheelbaseOutputTable: boolean;
    transitionalRegimeTable: boolean;
    pressuresInTheSoilCalculationTable: boolean;
    metricCalculationTable: boolean;
    priceTable: boolean;
    drainSymmetric: boolean
}

export const initialUtil = {
    stableSlopeAssessmentTable: true,
    drainageCapacityTable: true,
    drainingDrainPipesCalculationTable: true,
    wheelbaseOutputTable: true,
    transitionalRegimeTable: true,
    pressuresInTheSoilCalculationTable: true,
    metricCalculationTable: true,
    priceTable: true,
    drainSymmetric: true,
};

const initialState: IReduxState<IUtil> = {
    status: EReduxState.initialState,
    data: initialUtil,
};

export const utilSlice = createSlice({
    name: 'util',
    initialState,
    reducers: {
        setUtil: (state, action: PayloadAction<IUtil>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { setUtil } = utilSlice.actions;

export const selectUtil = (state: RootState) => state.util;

export default utilSlice.reducer;
